export enum EExamTypes {
  'ONSITE' = 'ONSITE',
  'DELIVERABLE' = 'DELIVERABLE',
  'ONLINE' = 'ONLINE'
}
